module.exports = __webpack_public_path__ + "img/plantbox_logo.886c56e6.png";